import Popper from 'popper.js'
import helper from './helper'

function contains( el, className ){
    if (el.classList)
        el.classList.contains(className);
    else
        new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
}


class Tooltip {

    constructor(){

        let _this = this

        _this.popper = null

        document.addEventListener( 'click', function(e){ return _this.clickHandler(e)})
        document.addEventListener( 'touchstart', function(e){ return _this.clickHandler(e)})
        document.addEventListener( 'keyup', function(e){ return _this.keyHandler(e)})

    }

    keyHandler(e){
        if(e.keyCode === 27 ) {
            this.removeTooltip()
        }
    }

    clickHandler(e){
        let target = e.target
        
        if( contains(target, 'tooltip') || target.closest('.tooltip') ){
            if( e.type == 'click' ){
                if( this.popper == null ){
                    this.createTooltip( target.closest('.tooltip') )
                } else {
                    this.removeTooltip()
                }
            } 
        } else if( contains(target, 'tooltip__inner') || target.closest('.tooltip__inner')) {
            if( contains(target, 'tooltip__close') || target.closest('.tooltip__close') ) {
                this.removeTooltip()
            }
        } else {
            if( document.querySelectorAll('.tooltip-on').length ) {
                this.removeTooltip()
            }
        }
    }

    createTooltip(el){
        
        if(this.popper) this.removeTooltip()

        let originalTooltip = el.querySelector('.tooltip__inner')
        if( !originalTooltip ) throw new Error('tooltips.js: original element not found')
        let instance = originalTooltip.cloneNode(true);
        let placement = el.getAttribute('data-placement') || 'left'


        instance.classList.add( 'tooltip-on' )
        
        document.body.appendChild( instance )

        this.popper = new Popper(el, instance, {
            removeOnDestroy: true,
            placement: placement,
            modifiers: {
                flip: {
                    behavior: [placement, 'bottom', 'top']
                },
                preventOverflow: {
                    boundariesElement: document.body,
                }
            }
        });

        helper.triggerEvent( window, 'scroll' )
    }

    removeTooltip(){
        if( !this.popper ) return
        this.popper.destroy()
        this.popper = null
    }
}


export default new Tooltip()